<div class="popup-container">

  <div class="header text-middle roboto-medium">Select Columns</div>

  <div id="box">
    <label class="checkcontainer mt-3 ps-5">
      <input class="check" (change)="onSelectAllChange(selectAllCheckBox)" [(ngModel)]="selectAllCheckBox" id="up"
        type="checkbox" />
      <span class="checkmark ms-3"></span>Select All
    </label>
    <hr class="blue" />
    <div *ngFor="let item of checkboxItems">
      <ng-container *ngIf="item.colName=='Type'; else others">
      <label class="checkcontainer ps-5">
        <input type="checkbox" (change)="preferences(item)" class="check"
          [(ngModel)]="item.checkVar" />Event Type 
        <span class="checkmark ms-3"></span>
      </label>
    </ng-container>
      <ng-template #others>
        <label class="checkcontainer ps-5">
          <input type="checkbox" (change)="preferences(item)" class="check"
            [(ngModel)]="item.checkVar" />{{ item.colName }}
          <span class="checkmark ms-3"></span>
        </label>
      </ng-template>
      <hr class="blue" />
    </div>

  </div>
  <!-- <br />  -->
  <div class="right-align">
    <button (click)="onClmnOptCancel()" id="cancel">CANCEL</button>
    <button (click)="getCheckedItems()" id="ok">OK</button>
  </div>


  <button mat-button mat-dialog-close (click)="onClmnOptCancel()" class="close black-button">
    X
  </button>
</div>